import errorHandling from './error-handling';
import Helpers from './helpers';

export default class ValidateForm {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('submit', (e) => {
				e.preventDefault();
				Helpers.disableAllButtons(el);
				const validationElements = el.querySelectorAll('[data-validation]');
				if (validationElements.length > 0) {
					const noErrors = errorHandling(validationElements);
					if (noErrors) {
						el.submit();
					} else {
						Helpers.enableAllButtons(el);
					}
				}
			});
		});
	}
}
